import { render, staticRenderFns } from "./AboutMeComponent.vue?vue&type=template&id=77ec0767&scoped=true&"
import script from "./AboutMeComponent.vue?vue&type=script&lang=js&"
export * from "./AboutMeComponent.vue?vue&type=script&lang=js&"
import style0 from "./AboutMeComponent.vue?vue&type=style&index=0&id=77ec0767&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ec0767",
  null
  
)

export default component.exports